import React from 'react';
import { Alert } from 'reactstrap';

// Based on the basic error boundary component from React docs.

export default class ErrorBoundary extends React.Component<{ children?: React.ReactNode }, { hasError: boolean }> {
    constructor(props: { children?: React.ReactNode }) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(/*  error: unknown, errorInfo: {componentStack: unknown} */) {
        // TODO: log the error to an error reporting service?
    }

    render() {
        if (this.state.hasError) {
            return (
                <Alert color="danger" role="alert">
                    Something has gone wrong while loading and displaying this section. You can refresh the page to try
                    again.
                </Alert>
            );
        }
        return this.props.children;
    }
}
